var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDemo = function SvgDemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.988 4.944 1.852 14.112h-5.482l-1.431-3.666H9.994l-1.506 3.666H3.16L5.011 4.944zM7.981 7.7v1.625H6.355v1.626h1.626v1.625h1.623V10.95h1.627V9.324H9.606V7.7zm7.61 3.251v1.625h1.625V10.95zM13.968 7.7v1.624h1.625V7.7z"
  })));
};
export default SvgDemo;